import PropTypes from "prop-types";
import React from "react";
import { maskMap } from "@defi/core-utils";
import { noop, returnTrue, charIsNumber, escapeRegExp, fixLeadingZero, limitToScale, roundToPrecision, omit, setCaretPosition, splitDecimal, findChangedIndex, clamp, applyThousandSeparator, getCurrentCaretPosition } from "./maskUtilities";
const propTypes = {
  displayType: PropTypes.oneOf(["input", "text"]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onValueChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.oneOf(["text", "tel", "password"]),
  mask: PropTypes.object,
  renderText: PropTypes.func,
  getInputRef: PropTypes.func
};
const defaultProps = {
  displayType: "input",
  type: "text",
  mask: {
    hasMask: false
  },
  onValueChange: noop,
  onChange: noop,
  onKeyDown: noop,
  onMouseUp: noop,
  onFocus: noop,
  onBlur: noop,
  getInputRef: noop
};
class MaskedInput extends React.Component {
  constructor(props) {
    super(props);
    /** caret specific methods ends **/
    this.formatValue = value => {
      if (this.props.mask.hasMask) {
        if (this.props.mask.editMask) {
          return maskMap.getMaskedValue(value, this.props.mask.editMask, true);
        } else {
          return maskMap.getMaskedValue(value, this.props.mask.readEditMask, true);
        }
      } else {
        return value;
      }
    };
    const defaultValue = props.defaultValue; // console.log(defaultValue);
    const formattedValue = this.props.value;
    this.state = {
      value: formattedValue
    };
    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };
    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }
  componentDidUpdate(prevProps) {
    this.updateValueIfRequired(prevProps);
  }
  shouldComponentUpdate(nextState, nextProps) {
    // console.log(nextProps.value);
    // console.log(this.state.value);
    // console.log(nextProps.value != this.state.value);
    return nextProps.value != this.state.value;
  }
  updateValueIfRequired(prevProps) {
    const props = this.props,
      state = this.state,
      focusedElm = this.focusedElm;
    const stateValue = state.value;
    if (prevProps !== props) {
      const formattedValue = this.formatValue(props.value); // === undefined ? lastValueWithNewFormat : this.formatValueProp();

      if (
      //set state always when not in focus and formatted value is changed
      focusedElm === null && formattedValue !== stateValue) {
        this.updateValue({
          formattedValue,
          input: focusedElm
        });
      }
    }
  }

  /** caret specific methods **/
  setPatchedCaretPosition(el, caretPos, currentValue) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    setTimeout(() => {
      if (el.value === currentValue) setCaretPosition(el, caretPos);
    }, 0);
  }

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  correctCaretPosition(value, caretPos, direction) {
    const format = this.props.format; //if value is empty return 0
    if (value === "") return 0;

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);
    return caretPos;
  }
  getCaretPosition(inputValue, formattedValue, caretPos) {
    caretPos += formattedValue.length - inputValue.length;
    return caretPos;
  }
  /** Update value and caret position */
  updateValue(params) {
    let onUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    const formattedValue = params.formattedValue,
      input = params.input;
    let caretPos = params.caretPos;
    const lastValue = this.state.value; //set caret position, and value imperatively when element is provided
    if (input) {
      //calculate caret position if not defined
      if (!caretPos) {
        const inputValue = params.inputValue || input.value;
        const currentCaretPosition = getCurrentCaretPosition(input);
        // console.log(currentCaretPosition)
        // get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
        // console.log(caretPos)
      }

      //set the value imperatively, this is required for IE fix
      input.value = formattedValue;

      //set caret position
      this.setPatchedCaretPosition(input, caretPos, formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({
        value: formattedValue
      }, () => {
        onUpdate();
      });
    } else {
      onUpdate();
    }
  }
  onChange(e) {
    e.persist();
    const el = e.target;
    let inputValue = el.value;
    const state = this.state,
      props = this.props;
    const currentCaretPosition = getCurrentCaretPosition(el);
    let formattedValue = this.formatValue(inputValue) || "";
    // console.log("onChange: " + inputValue + ' - ' + formattedValue)

    this.updateValue({
      formattedValue,
      inputValue,
      input: el
    }, () => {
      // props.onChange(e);
    });
  }
  onBlur(e) {
    const props = this.props,
      state = this.state;
    const format = props.format,
      onBlur = props.onBlur; // let {numAsString} = state;
    const lastValue = state.value;
    this.focusedElm = null;
    if (!format) {
      const formattedValue = this.formatValue(lastValue);
      // console.log("onBlur: " + lastValue + ' - ' + formattedValue)
      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        e.persist();
        this.updateValue({
          formattedValue
        }, () => {
          onBlur(e);
        });
        return;
      }
    }
    onBlur(e);
  }
  onKeyDown(e) {
    const el = e.target;
    const key = e.key;
    const selectionStart = el.selectionStart,
      selectionEnd = el.selectionEnd,
      _el$value = el.value,
      value = _el$value === void 0 ? "" : _el$value;
    let expectedCaretPosition;
    const _this$props = this.props,
      format = _this$props.format,
      onKeyDown = _this$props.onKeyDown;
    this.selectionBeforeInput = {
      selectionStart,
      selectionEnd
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === "ArrowLeft" || key === "Backspace") {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === "ArrowRight") {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === "Delete") {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }
    let newCaretPosition = expectedCaretPosition;
    const leftBound = 0; //isPatternFormat ? format.indexOf('#') : prefix.length;
    const rightBound = value.length; //isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;
    // console.log("onKeyDown: " + value + ' - ' + key)
    if (key === "ArrowLeft" || key === "ArrowRight") {
      const direction = key === "ArrowLeft" ? "left" : "right";
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (key === "Delete") {
      while (newCaretPosition < rightBound) newCaretPosition++;
    } else if (key === "Backspace") {
      /* NOTE: This is special case when backspace is pressed on a
         negative value while the cursor position is after prefix. We can't handle it on onChange because
         we will not have any information of keyPress
         */
      if (selectionStart <= leftBound + 1 && value[0] === "-" && typeof format === "undefined") {
        const newValue = value.substring(1);
        //persist event before performing async task
        e.persist();
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el
        });
      }
    }
    if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }
    this.props.onKeyDown(e);
  }

  /** required to handle the caret position when click anywhere within the input **/
  onMouseUp(e) {
    const el = e.target;

    /**
       * NOTE: we have to give default value for value as in case when custom input is provided
       * value can come as undefined when nothing is provided on value prop.
      */
    const selectionStart = el.selectionStart,
      selectionEnd = el.selectionEnd,
      _el$value2 = el.value,
      value = _el$value2 === void 0 ? "" : _el$value2; // console.log("onMouseUp: " + value)
    if (selectionStart === selectionEnd) {
      const caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }
    this.props.onMouseUp(e);
  }
  onFocus(e) {
    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();
    this.focusedElm = e.target;
    setTimeout(() => {
      const el = e.target;
      const selectionStart = el.selectionStart,
        selectionEnd = el.selectionEnd,
        _el$value3 = el.value,
        value = _el$value3 === void 0 ? "" : _el$value3; //console.log("onFocus: " + value)
      const caretPosition = this.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }

      //this.props.onFocus(e);
    }, 0);
  }
  render() {
    const _this$props2 = this.props,
      type = _this$props2.type,
      displayType = _this$props2.displayType,
      customInput = _this$props2.customInput,
      renderText = _this$props2.renderText,
      getInputRef = _this$props2.getInputRef,
      mask = _this$props2.mask;
    const value = this.state.value;
    const otherProps = omit(this.props, propTypes);
    const inputProps = Object.assign({}, otherProps, {
      type,
      value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    if (displayType === "text") {
      return renderText ? renderText(value) || null : /*#__PURE__*/React.createElement("span", Object.assign({}, otherProps, {
        ref: getInputRef
      }), value);
    } else if (customInput) {
      const CustomInput = customInput;
      return /*#__PURE__*/React.createElement(CustomInput, Object.assign({}, inputProps, {
        mask: mask,
        ref: getInputRef
      }));
    }
    return /*#__PURE__*/React.createElement("input", Object.assign({}, inputProps, {
      ref: getInputRef
    }));
  }
}
MaskedInput.defaultProps = defaultProps;
export default MaskedInput;